import { combineReducers } from 'redux';
import {
  USER_INFO,
  IsetUserInfo,
  IuserInfo,
  IsetWareHouseList,
  WARE_HOUSE_LIST,
  IwarehouseList,
  IsetLoading,
  LOADING,
} from './types';

export const SCOPE_NAME = 'SHARE_DATA';

// 容器
const userInfo = (
  state = {
    user: {
      id: '',
      name: '',
    },
  } as IuserInfo,
  action: IsetUserInfo
) => {
  const { payload, type } = action;
  switch (type) {
    case USER_INFO:
      return payload;
    default:
      return state;
  }
};

// 容器
const warehouseList = (
  state: IwarehouseList[] = [],
  action: IsetWareHouseList
) => {
  const { payload, type } = action;
  switch (type) {
    case WARE_HOUSE_LIST:
      return payload;
    default:
      return state;
  }
};

const loading = (state = false, action: IsetLoading) => {
  const { payload, type } = action;
  switch (type) {
    case LOADING:
      return payload;
    default:
      return state;
  }
};

const SHARE_DATA = combineReducers({
  userInfo,
  warehouseList,
  loading,
});

export default SHARE_DATA;
